const SOCIAL_NETWORK_MAP: Record<string, string> = {
  facebook: 'facebook',
  instagram: 'instagram',
  youtube: 'youtube',
  tiktok: 'tiktok',
};

export const getSocialNetworkFromUrl = (url: string): string => {
  const lowerCaseUrl = url.toLowerCase();
  const matchedNetwork = Object.keys(SOCIAL_NETWORK_MAP).find((key) =>
    lowerCaseUrl.includes(key),
  );
  return matchedNetwork ? SOCIAL_NETWORK_MAP[matchedNetwork] : '';
};
